import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { EGRESOSINGRESOS_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'

export default function EgresosIngresosPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${EGRESOSINGRESOS_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
